<template>
  <div class="invest-wrap">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      v-if="list.length != 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-cell
          v-for="(item, index) in list"
          :key="index"
          @click="Detail(item.id, item.surplus)"
        >
          <img class="bg" :src="item.poster" @error="nofind()" />
          <div class="label" v-if="item.status == 1">
            <img
              v-if="item.project_type == 2"
              src="../../assets/myInvest/long.png"
            />
            <img
              v-if="item.project_type == 1"
              src="../../assets/myInvest/label_1.png"
            />
          </div>
          <div
            class="label"
            v-if="item.status == 2 || item.status == 3 || item.status == 4"
          >
            <img src="../../assets/myInvest/finished.png" />
          </div>
          <div
            class="label"
            v-if="item.status == -1 || item.status == -2 || item.status == -3"
          >
            <img src="../../assets/myInvest/failed.png" />
          </div>
          <div class="describe">
            <div class="box">
              <p class="name">{{ item.project_name }}</p>
              <p class="address">{{ item.invest_store_address }}</p>
              <p
                class="speed"
                v-if="item.project_type == 1 && item.member_order_exist"
              >
                <span :style="{ width: item.prograss + '%' }"></span>
              </p>
              <p
                class="prograss"
                v-if="item.project_type == 1 && item.member_order_exist"
              >
                <!-- 已有{{ item.order_count.member_count }}人认购{{
                  item.order_count.shares_sum
                }}股 -->
                <span
                  >剩余{{ item.surplus }}天 | 目标
                  {{ item.target_shares }}股</span
                >
              </p>
              <p class="info">{{ item.intro }}</p>
            </div>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <van-row class="empty" v-if="list.length == 0 && !hasList">
      <van-col class="emptyMsg" span="24">
        <img src="../../assets/myInvest/empty.png" />
        <p class="tip">暂无众筹项目</p>
      </van-col>
    </van-row>
    <div class="loading" v-if="list.length <= 0 && hasList">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
import defaultImg from "@/assets/common/ListPreload.png";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      this.$api
        .get("/investment/member/project/list")
        .then((res) => {
          this.allList = res.total;
          if (res.list.length == 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              if (
                res.list[i].project_type == 1 &&
                res.list[i].member_order_exist
              ) {
                res.list[i].prograss =
                  (res.list[i].order_count.shares_sum /
                    res.list[i].target_shares) *
                  100;
                if (res.list[i].prograss < 1) {
                  res.list[i].prograss = 1;
                }
                res.list[i].surplus = this.timeDiff(
                  res.list[i].invest_end_time
                );
              }
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
             this.finished = true;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
            this.timeout = true;
          } else {
            this.$toast(message);
          }
        });
    },
    Detail(id, day) {
      this.$router.push({
        path: "/myInvest/detail",
        query: {
          id: id,
        },
      });
    },
    timeDiff(end_time) {
      var endTime = this.date2timestamp(end_time);
      var current = Math.floor(new Date().getTime() / 1000);
      var ts = endTime - current;
      if (ts <= 0) {
        return 0;
      } else {
        var dd = parseInt(ts / 60 / 60 / 24, 10);
        return dd;
      }
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>
<style lang="less" scoped>
.invest-wrap{
  overflow-y: auto;
}
</style>
<style lang="less">
.invest {
  &-wrap {
    background: #fff;
    height: 100%;
    box-sizing: border-box;
    padding: 69px 16px 56px;
    .van-pull-refresh {
      height: 100%;
      -webkit-overflow-scrolling: touch;
      .van-cell {
        height: 257px;
        border-radius: 5px;
        margin-top: 16px;
        position: relative;
        padding: 0;
        .bg {
          width: 100%;
          height: 257px;
          border-radius: 5px;
          background: #f5f5f5;
        }
        .label {
          position: absolute;
          left: 0;
          top: 0;
          padding: 17px 18px 0;
          img {
            width: 84px;
          }
        }
        .describe {
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          color: #fff;
          font-size: 12px;
          background: -webkit-linear-gradient(
            rgba(255, 255, 255, 0),
            rgba(0, 0, 0, 0.9)
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            rgba(255, 255, 255, 0),
            rgba(0, 0, 0, 0.9)
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            rgba(255, 255, 255, 0),
            rgba(0, 0, 0, 0.9)
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(
            rgba(255, 255, 255, 0),
            rgba(0, 0, 0, 0.9)
          );
          .box {
            padding: 16px;
            .name {
              font-size: 20px;
              /*height: 28px;*/
              line-height: 28px;
              margin-bottom: 5px;
              /*white-space: nowrap;*/
              font-weight: bold;
            }
            .address {
              color: rgba(255, 255, 255, 0.7);
              font-size: 13px;
            }
            @media screen and (max-width: 320px) {
              .address {
                font-size: 12px;
              }
            }
            .speed {
              height: 3px;
              border-radius: 3px;
              position: relative;
              margin-top: 8px;
              background: rgba(255, 255, 255, 0.3);
              span {
                /*width: 30%;*/
                height: 3px;
                display: inline-block;
                border-radius: 3px;
                background: #fff;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
            .prograss {
              line-height: 23px;
              padding-top: 3px;

              span {
                float: right;
              }
            }
            .info {
              max-height: 48px;
              line-height: 24px;
              margin-top: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            @media only screen and (min-width: 320px) and (max-width: 374px) {
              .name {
                font-size: 17px;
                margin-bottom: 6px;
              }
              .prograss {
                line-height: 24px;
                margin-bottom: 2px;
              }
              .info {
                max-height: 40px;
                line-height: 20px;
              }
            }
          }
        }
      }
      .van-cell:not(:last-child)::after {
        border: none;
      }
      @media only screen and (min-width: 320px) and (max-width: 374px) {
        .van-cell {
          height: 215px;
          border-radius: 5px;
          .bg {
            height: 215px;
            border-radius: 5px;
          }
        }
      }
    }
    .empty {
      padding-top: 137px;
      .emptyMsg {
        text-align: center;
        img {
          width: 106px;
          display: inline-block;
        }
        .tip {
          color: #cccccc;
          font-size: 14px;
          margin-top: 17px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;
      img {
        width: 35%;
        margin-top: 50%;
      }
    }
  }
}
.isiOSX {
  .invest-wrap {
    padding-top: 89px;
  }
}
</style>
